import request from '@/utils/request'

const api_name = '/api/evaluation/stepRealTimeReview'

/**
 * 实时评审
 */
export default {

    //列表
    getReviewResultList(bidSectionCode) {
        return request.get(`${api_name}/list/?bidSectionCode=${bidSectionCode}`)
    },

    //评审结果详情
    getReviewResultDetail(data) {
        return request.get(`${api_name}/resultDetail?stepId=${data.stepId}&stepTypeCode=${data.stepTypeCode}&bidSectionCode=${data.bidSectionCode}`)
    }
}